module.exports = __webpack_public_path__ + "img/bg_resize_castle_front.befb9a25.png";